import { Assessment, ListAlt } from '@mui/icons-material';
import { lazy } from 'react';
import { Permissions } from 'services/enums';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const NotificationLogsPage = lazy(() => import('pages/GeneralLogsPages/NotificationLogsPage'));
const ReportPage = lazy(() => import('pages/ReportPage'));

export const auditRoutes: IRouteProps[] = [
	{
		type: 'collapse',
		name: 'routersNames.report',
		key: 'report',
		icon: <Assessment />,
		route: `${DEFAULT_ROUTE}/report`,
		permissionId: [Permissions.DEVICES],
		component: <ReportPage />,
		protected: true,
	},
	{
		type: 'collapse',
		name: 'routersNames.notificationLogs',
		key: 'notification-logs',
		icon: <ListAlt />,
		route: `${DEFAULT_ROUTE}/notification-logs`,
		permissionId: [Permissions.ALL],
		component: <NotificationLogsPage />,
		protected: true,
	},
];
